import Swiper from 'swiper';

const homeSlider = document.querySelector('.js-hero-slider');
if(homeSlider) {
    var swiper = new Swiper(homeSlider, {
        pagination: {
            el: '.js-pagination',
            type: "custom",
            renderCustom:  function (swiper, current, total) {
                return  '<div class="pagination-content"><span class="swiper-pagination-current">'+ current + '</span> / <span class="swiper-pagination-total">'+ total +'</span></div>'
                      + '<progress max="'+total+'" value="'+ current +'"></progress>';
            },
        },
        loop: true,
        speed: 800,
        grabCursor: true,
        watchSlidesProgress: true,
        mousewheelControl: true,
        keyboardControl: true,
        effect: 'fade',
        navigation: {
          nextEl: '.js-slider-button-next',
          prevEl: '.js-slider-button-prev',

        },
    });
}
